export default "__VITE_PUBLIC_ASSET__d531967c__"